<template>
  <el-dialog
    append-to-body
    width="500px"
    title=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">发送入职offer</div>
    </template>
    <div style="margin-bottom: 10px; padding-left: 18px;">
      <span style="font-weight: 200;">企业: </span>
       {{ companyName }}
    </div>
    <div style="margin-bottom: 10px; padding-left: 18px;">
      <span style="font-weight: 200;">致: </span>
       {{ currentRow.nickname }}
    </div>
    <el-form
      class="staff-from"
      ref="elFormDom"
      :model="form.data"
      :rules="form.rules"
      hide-required-asterisk
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="offer_tips">
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.data.offer_tips"
              clearable
              placeholder="请填写入职邀请信息,如: 入职时间、入职材料"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >确定邀请入职</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { mixinTable } from "@/mixins/tableCompany.js";
import { getStorage } from "@/storage";
export default {
  mixins: [mixinTable],
  data() {
    return {
      companyName:getStorage('name'),
      visible: false,
      currentRow: {},
      form: {
        loading: false,
        data: {
          offer_tips: "",
        },
        rules: {
          offer_tips: [
            { required: true, message: "必填项", trigger: "change" },
          ],
        },
      },
    };
  },
  created() {},
  methods: {
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getdetails(row) {
      this.currentRow = row;
    },
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            status: 5,
            id: this.currentRow.id,
            offer_tips: this.form.data.offer_tips,
          };
          this.$http
            .post("/company/resume/operation", params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("发送成功,等待对方确认");
                this.toggle(false);
                this.$emit("update");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>